module.exports = __webpack_public_path__ + "static/img/hcp-ladder-brintellix-4-2.ee95029b.png";